/**
 * Состояние всплывашки с опопвещениями после изменения данных на странице
 * Находится в APP
 */
const state = {
  // вкл./выкл. popup
  popupInfoActive: false,
  // текст сообщения
  popupInfoText: "",
  // тип popup
  popupType: "info",
  // Timeout для закрытия всплывашки
  popupInfoTimeout: 2000,
  // Для указания дествия во всплывашке
  popupInfoAction: {}
};

const mutations = {
  // вкл./выкл. popup
  SET_POPUP_INFO_ACTIVE(state, val) {
    state.popupInfoActive = val;
  },
  // смена текста сообщения
  SET_POPUP_INFO_TEXT(state, val) {
    state.popupInfoText = val;
  },
  // смена background
  SET_POPUP_TYPE(state, val) {
    state.popupType = val;
  },
  // смена Timeout
  SET_POPUP_INFO_TIMEOUT(state, val) {
    state.popupInfoTimeout = val;
  },
  // название действия
  SET_POPUP_INFO_ACTION(state, val) {
    state.popupInfoAction = val;
  },
  // чистка параметров popup
  CLEAR_POPUP_INFO(state) {
    state.popupInfoActive = false;
    state.popupInfoText = "";
    state.popupType = "info";
    state.popupInfoTimeout = 2000;
    state.popupInfoAction = {};
  }
};

const actions = {
  // открывает всплывашку с переданными параметрами
  popupInfoOpen({ commit }, params) {
    if (params.timeout) commit("SET_POPUP_INFO_TIMEOUT", params.timeout);
    if (params.text) commit("SET_POPUP_INFO_TEXT", params.text);
    if (params.type) commit("SET_POPUP_TYPE", params.type);
    if (params.action) commit("SET_POPUP_INFO_ACTION", params.action);
    commit("SET_POPUP_INFO_ACTIVE", true);
  }
};

const getters = {
  // вкл./выкл. popup
  popupInfoActive: state => {
    return state.popupInfoActive;
  },
  // текст сообщения
  popupInfoText: state => {
    return state.popupInfoText;
  },
  // текст сообщения
  popupInfoTimeout: state => {
    return state.popupInfoTimeout;
  },
  // background popup
  popupType: state => {
    return state.popupType;
  },
  popupInfoAction: state => {
    return state.popupInfoAction;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
